// 작업 끝 상태 가르기 — AIRocketReg runWork · startQueue 조각 훑기 · autoFullProcess 가 같은 기준으로 실패를 고른다.
// 예전엔 runWork·startQueue 가 상태 'error' 만 실패로 세어, 견적서가 processing 에 남은 건이 «다 됐다» 로 보였다(2B2E83 · 10-18 seroha).
// 끝 상태 = completed · partially_completed · error · disabled(사이즈표가 필요 없는 카테고리 — workflowService.isTaskCompleted 와 같음).
// 그 밖(processing·pending·빈 값)은 «안 끝남» — 실패로 싣는다.
const END_STATES = ['completed', 'partially_completed', 'error', 'disabled']

export function taskStatus(product, task) {
  const v = product ? product[`${task}Status`] : undefined
  return v && typeof v === 'object' ? v.status : v
}

/** @returns {{ failed: string[], partial: string[], unfinished: string[] }} 물은 작업(tasks)만 가른다 */
export function workOutcome(product, tasks) {
  const out = { failed: [], partial: [], unfinished: [] }
  for (const t of tasks) {
    const s = taskStatus(product, t)
    if (s === 'error') out.failed.push(t)
    else if (s === 'partially_completed') out.partial.push(t)
    else if (!END_STATES.includes(s)) out.unfinished.push(t)
  }
  return out
}
